 <div class="d-flex flex-column justify-content-center">
   <img class="d-inline-flex justify-content-center" src="{{'data:image/jpg;base64,' + data.shipment.sig}}" />
   <span class="text-1216 py-2 bold d-inline-flex justify-content-center">{{data.shipment.cnee}}</span>

   <span
     class="text-1216 light pb-3 ke-color-gray d-inline-flex justify-content-center">{{data.shipment_status[0].s_date}}</span>
   <div class="d-inline-flex justify-content-center">
     <button class="ke-btn-primary ke-background-primary text-1216" style="padding: 3px 40px;color: white; "
       mat-dialog-close type="button"><span>{{'g.close'|translate}}</span></button>
   </div>
 </div>
